import React from "react";
import PropTypes from "prop-types";

const ErrorInput = ({ touched, error }) => {
  if (touched && error) {
    return (
      <div className="mt-1">
        <span className="badge rounded-pill bg-danger">{error}</span>
      </div>
    );
  }
  return null;
};

ErrorInput.propTypes = {
  touched: PropTypes.bool,
  error: PropTypes.string,
};

export default ErrorInput;
